import React from 'react';
import { Col, Row, Input, Label } from 'reactstrap';

const DeliveryVesselSecondLocation = ({
  form,
  deliveryincotermformData,
  handleDeliveryNumberChangeIncoterm,
}) => {
  return (
    <Row>
      <Col sm={8}>
        <Row>
          <Col sm={12}>
            <div className='mb-2'>
              <Label className='form-label fw-semibold'>
                {deliveryincotermformData.incotermLocation2Name}{' '}
              </Label>
            </div>
          </Col>

          {/* Draft */}
          <Col sm={4}>
            <div className='mb-2'>
              <Label className='form-label'>Draft (m)</Label>
              <div className='input-group mb-2'>
                <span className='input-group-text'>Min</span>
                <Input
                  type='number'
                  name='loc2Draft1'
                  value={deliveryincotermformData.loc2Draft1 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc2Draft1')}
                />
                <span className='input-group-text'>m</span>
              </div>
              <div className='input-group'>
                <span className='input-group-text'>Max</span>
                <Input
                  type='number'
                  name='loc2Draft2'
                  value={deliveryincotermformData.loc2Draft2 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc2Draft2')}
                />
                <span className='input-group-text'>m</span>
              </div>
            </div>
          </Col>

          {/* LOA */}
          <Col sm={4}>
            <div className='mb-2'>
              <Label className='form-label'>LOA (m)</Label>
              <div className='input-group mb-2'>
                <span className='input-group-text'>Min</span>
                <Input
                  type='number'
                  name='loc2Loa1'
                  value={deliveryincotermformData.loc2Loa1 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc2Loa1')}
                />
                <span className='input-group-text'>m</span>
              </div>
              <div className='input-group'>
                <span className='input-group-text'>Max</span>
                <Input
                  type='number'
                  name='loc2Loa2'
                  value={deliveryincotermformData.loc2Loa2 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc2Loa2')}
                />
                <span className='input-group-text'>m</span>
              </div>
            </div>
          </Col>

          {/* DWT */}
          <Col sm={4}>
            <div className='mb-2'>
              <Label className='form-label'>DWT (MT)</Label>
              <div className='input-group mb-2'>
                <span className='input-group-text'>Min</span>
                <Input
                  type='number'
                  name='loc2Dwt1'
                  value={deliveryincotermformData.loc2Dwt1 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc2Dwt1')}
                />
                <span className='input-group-text'>m</span>
              </div>
              <div className='input-group'>
                <span className='input-group-text'>Max</span>
                <Input
                  type='number'
                  name='loc2Dwt2'
                  value={deliveryincotermformData.loc2Dwt2 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc2Dwt2')}
                />
                <span className='input-group-text'>m</span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DeliveryVesselSecondLocation;
